import React, { FC, RefObject, useState } from 'react';

import { ParsedPubnubMessage, RaiseHandMessage, PubnubMsgsItem } from 'client/redux/pubnub/types';

import WaiterOnClickPopup from '../../Popups/WaiterOnClickPopup';
import ListenerIcon from '../ListenerIcon';

import css from './WaitersList.module.scss';

type Props = {
  data: PubnubMsgsItem;
  style: React.CSSProperties;
  onItemClick: (itemId: string | undefined) => void;
  activeId: string | null;
  onControlPopUpClick: () => void;
};

export const Waiter: FC<Props> = (props) => {
  const { data, style, onItemClick, activeId, onControlPopUpClick } = props;
  const [listenerRef, setListenerRef] = useState<RefObject<HTMLDivElement>>();
  const listenerData = React.useMemo<RaiseHandMessage>(() => {
    const parsedMessage: ParsedPubnubMessage = JSON.parse(data.message);
    const actualMsgData = Object.keys(data.actions?.update || {});
    const actualMsgDataParsed: ParsedPubnubMessage = JSON.parse(actualMsgData?.[0] || '{}');

    return {
      id: data.uuid as string,
      name: parsedMessage.name as string,
      alreadySpeakTotal: actualMsgDataParsed.alreadySpeakTotal || parsedMessage.alreadySpeakTotal,
      messageTimeToken: data.timetoken,
    };
  }, [data]);

  const onClick = React.useCallback(() => {
    onItemClick(data.uuid);
  }, [data.uuid, onItemClick]);

  if (!data.uuid) {
    return null;
  }

  return (
    <div className={css.listItem} key={data.uuid} data-id={data.uuid} onClick={onClick} style={style}>
      {activeId === data.uuid && (
        <WaiterOnClickPopup
          onClose={onControlPopUpClick}
          listenerData={listenerData}
          className={css.controlsPopup}
          itemRef={listenerRef}
        />
      )}
      <ListenerIcon
        name={listenerData.name}
        wantToSpeak
        timesSpoke={listenerData.alreadySpeakTotal}
        isActive={data.uuid === activeId}
        setRef={setListenerRef}
      />
    </div>
  );
};
